var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useRef, useState } from "react";
import Title from "../../App/components/Title";
import "../styles/TicketHistory.css";
import ModalUploadTicket from "./ModalUploadTicket";
import { useLocation, useParams } from "react-router-dom";
import SubmissionsForProviderApprovalService from "../services/SubmissionsForProviderApprovalService";
import Chip from '@mui/material/Chip';
import ModalApproveOrDisapproveArt from "./ModalApproveOrDisapproveArt";
import ArtsApprovalService from "../services/ArtsApprovalService";
import useAuth from "../../App/hooks/useAuth";
import { customerEmployeeRole, customerRole, designerRole } from "../../App/helpers/RoleHelper";
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import Notification from "../../App/components/Notification";
import FilesTodownload from "../components/FilesToDownload";
import { formatDate } from "../../App/utils/formatter";
import MemberHandbookService from "../../MemberHandbook/services/MemberHandbookService";
import { setClarityTag } from "../../App/utils/clarity";
function selectedFailOption(labels, disapprovalOptionId) {
    if (!labels || labels === 'null') {
        return false;
    }
    var labelsArray;
    try {
        labelsArray = JSON.parse(labels);
    }
    catch (error) {
        return false;
    }
    if (!Array.isArray(labelsArray)) {
        return false;
    }
    return labelsArray.includes(disapprovalOptionId);
}
function computeTicketFlags(artHistory, index, artHistories, authRoleId) {
    var isCustomer = authRoleId === customerRole || authRoleId === customerEmployeeRole;
    var isDisabled = isCustomer && [1, 2, 4].includes(artHistory.status_id);
    var statusIds = artHistories.map(function (h) { return h.status_id; });
    var lastUnderAnalysisIndex = statusIds.lastIndexOf(2);
    var lastStatusId = statusIds[0];
    var isUnderAnalysis = isCustomer && artHistory.status_id === 2;
    var isLastUnderAnalysis = index === lastUnderAnalysisIndex;
    var isEnabled = authRoleId === designerRole || artHistory.status_id !== 2;
    var canOpenAccordion = (artHistory.status_id === 1 && (authRoleId === customerRole || authRoleId === designerRole)) ||
        (artHistory.status_id !== 2 || authRoleId !== customerRole);
    var hasImageResponse = artHistory.image_response !== null;
    var prodUrl = process.env.REACT_APP_STORAGE_URL;
    var artLink;
    if (hasImageResponse) {
        artLink = "".concat(prodUrl, "/arts/").concat(artHistory.image_response);
    }
    else if (artHistory.art_type === "link") {
        artLink = artHistory.art_path;
    }
    else {
        artLink = "".concat(prodUrl, "/arts/").concat(artHistory.art_path);
    }
    return {
        isDisabled: isDisabled,
        lastStatusId: lastStatusId,
        isUnderAnalysis: isUnderAnalysis,
        isLastUnderAnalysis: isLastUnderAnalysis,
        isEnabled: isEnabled,
        canOpenAccordion: canOpenAccordion,
        hasImageResponse: hasImageResponse,
        artLink: artLink,
    };
}
function AttachmentAction(_a) {
    var artHistory = _a.artHistory, hasImageResponse = _a.hasImageResponse, artLink = _a.artLink;
    if (artHistory.status_id === 1) {
        return (_jsx(FilesTodownload, { type: artHistory.art_type === "link" ? "button" : "download", href: artHistory.art_type === "link"
                ? artHistory.art_path
                : "".concat(process.env.REACT_APP_STORAGE_URL, "/arts/").concat(artHistory.art_path) }));
    }
    if (artHistory.image_response === null) {
        return (_jsx("button", __assign({ type: "button", className: "open-attachment-button button-with-grey-border", disabled: true }, { children: "Abrir anexo" })));
    }
    return (_jsx(FilesTodownload, { type: (hasImageResponse || artHistory.art_type !== "link") ? "download" : "button", href: artLink }));
}
function TicketAccordionHeader(_a) {
    var artHistory = _a.artHistory, isOpen = _a.isOpen, isEnabled = _a.isEnabled, canOpenAccordion = _a.canOpenAccordion, onToggle = _a.onToggle;
    return (_jsxs("button", __assign({ type: "button", className: "button-ticket", id: "btn-toggle-ticket-".concat(artHistory.id), "aria-label": isOpen ? "Recolher detalhes de ".concat(artHistory.interacted_by_name) : "Expandir detalhes de ".concat(artHistory.interacted_by_name), onClick: function () { if (canOpenAccordion) {
            onToggle();
        } }, onKeyDown: function (e) { if ((e.key === 'Enter' || e.key === ' ') && canOpenAccordion) {
            onToggle();
        } }, tabIndex: 0, style: { pointerEvents: canOpenAccordion ? 'initial' : 'none' } }, { children: [(artHistory.status_id === 1 || artHistory.status_id === 6 || artHistory.status_id === 7) ? (_jsx("div", { children: artHistory.user_name })) : (_jsx("div", { children: artHistory.designer_name })), _jsx("div", __assign({ className: "status-button", style: { backgroundColor: artHistory.color, color: artHistory.color !== "#00000014" ? "#000" : "inherit" } }, { children: artHistory.art_status_translation })), _jsxs("div", __assign({ className: "date-formatted" }, { children: [" ", formatDate(artHistory === null || artHistory === void 0 ? void 0 : artHistory.updated_at)] })), _jsxs("div", __assign({ className: "ticket-details ".concat(!isEnabled ? 'disabled-details' : '') }, { children: ["Detalhes\u00A0", _jsxs("span", __assign({ className: "icon-details" }, { children: [_jsx(KeyboardArrowUpIcon, { className: "".concat(isOpen ? 'hidden-details' : '', " ").concat(!isEnabled ? 'disabled-icon' : '') }), _jsx(KeyboardArrowDownIcon, { className: "".concat(isOpen ? '' : 'hidden-details', " ").concat(!isEnabled ? 'disabled-icon' : '') })] }))] }))] })));
}
function TicketReportBody(_a) {
    var artHistory = _a.artHistory, disapprovalOptions = _a.disapprovalOptions, materialLink = _a.materialLink;
    return (_jsxs("div", __assign({ className: "ticket-report" }, { children: [artHistory.status_id !== 1 && artHistory.status_id !== 2 || (artHistory.status_id == 4) && (_jsx("p", { children: "Justificativa" })), artHistory.status_id === 5 ? (_jsxs(_Fragment, { children: [_jsx("p", { children: "Ol\u00E1, provedor! Recebemos a sua arte e agradecemos seu esfor\u00E7o e  colabora\u00E7\u00E3o! Confira abaixo os motivos da reprova\u00E7\u00E3o: " }), _jsx("div", __assign({ style: { display: "flex", flexWrap: "wrap", marginBottom: "1rem", gap: "1rem" } }, { children: disapprovalOptions.map(function (item) {
                            if (selectedFailOption(artHistory.label, item.id)) {
                                return (_jsx(Chip, { label: item.label }, item.id));
                            }
                        }) })), _jsx("div", { dangerouslySetInnerHTML: { __html: artHistory === null || artHistory === void 0 ? void 0 : artHistory.report } }), _jsxs("p", { children: ["Relembramos que voc\u00EA pode encontrar todos os recursos que precisa na \u00EDntegra dentro do nosso drive:", ' ', _jsxs("a", __assign({ href: materialLink, target: "_blank", rel: "noopener noreferrer", className: "text-black-50 fw-normal mb-0 second-text" }, { children: [" ", _jsx("br", {}), "LINK: ", materialLink] })), _jsx("br", {}), ' ', "Ap\u00F3s altera\u00E7\u00E3o, \u00E9 necess\u00E1rio que envie novamente para aprova\u00E7\u00E3o. Agradecemos desde j\u00E1!"] })] }))
                : (_jsx("div", { dangerouslySetInnerHTML: { __html: artHistory === null || artHistory === void 0 ? void 0 : artHistory.report } }))] })));
}
function TicketActions(_a) {
    var artHistory = _a.artHistory, index = _a.index, authRoleId = _a.authRoleId, authUserId = _a.authUserId, hasImageResponse = _a.hasImageResponse, artLink = _a.artLink, lastStatusId = _a.lastStatusId, isDisabledFlag = _a.isDisabledFlag, onContest = _a.onContest, onAssess = _a.onAssess;
    var isCustomer = authRoleId === customerRole || authRoleId === customerEmployeeRole;
    if (isCustomer) {
        var isRespondDisabled = (!artHistory.report && !artHistory.image_response && !artHistory.label) ||
            index !== 0 ||
            artHistory.status_id === 7;
        return (_jsxs(_Fragment, { children: [_jsx(AttachmentAction, { artHistory: artHistory, hasImageResponse: hasImageResponse, artLink: artLink }), artHistory.status_id !== 1 && artHistory.status_id !== 2 && (_jsx("button", __assign({ type: "button", id: "btn-respond-ticket-".concat(artHistory.id), className: "response-ticket-button ".concat(isRespondDisabled ? "gray-button" : "blue-button"), onClick: onContest, disabled: isRespondDisabled }, { children: "Responder" })))] }));
    }
    var isAssessDisabled = lastStatusId === 4 ||
        isDisabledFlag ||
        artHistory.status_id === 5 ||
        index !== 0 ||
        artHistory.status_id === 1 ||
        artHistory.designer_id !== authUserId;
    return (_jsxs(_Fragment, { children: [_jsx(AttachmentAction, { artHistory: artHistory, hasImageResponse: hasImageResponse, artLink: artLink }), _jsx("button", __assign({ type: "button", id: "btn-assess-ticket-".concat(artHistory.id), className: "response-ticket-button ".concat(isAssessDisabled ? "gray-button" : "blue-button"), onClick: onAssess }, { children: "Avaliar" }))] }));
}
function TicketHistoryItem(_a) {
    var artHistory = _a.artHistory, index = _a.index, artHistories = _a.artHistories, auth = _a.auth, disapprovalOptions = _a.disapprovalOptions, materialLink = _a.materialLink, isOpen = _a.isOpen, onToggle = _a.onToggle, onContest = _a.onContest, onAssess = _a.onAssess;
    var _b = computeTicketFlags(artHistory, index, artHistories, auth.role_id), isDisabled = _b.isDisabled, lastStatusId = _b.lastStatusId, isUnderAnalysis = _b.isUnderAnalysis, isLastUnderAnalysis = _b.isLastUnderAnalysis, isEnabled = _b.isEnabled, canOpenAccordion = _b.canOpenAccordion, hasImageResponse = _b.hasImageResponse, artLink = _b.artLink;
    return (_jsxs("div", __assign({ className: "accordion-ticket ".concat(isOpen ? 'open' : 'closed'), style: { display: (isUnderAnalysis && !isLastUnderAnalysis) ? 'none' : 'block' } }, { children: [_jsx("input", { type: "checkbox", id: "faq-".concat(artHistory.id) }), _jsx(TicketAccordionHeader, { artHistory: artHistory, isOpen: isOpen, isEnabled: isEnabled, canOpenAccordion: canOpenAccordion, onToggle: onToggle }), _jsxs("div", __assign({ className: "content-ticket", style: { height: isOpen ? "auto" : "0", maxHeight: isOpen ? "none" : "0" } }, { children: [_jsx(TicketReportBody, { artHistory: artHistory, disapprovalOptions: disapprovalOptions, materialLink: materialLink }), _jsx("div", __assign({ className: "container-actions-buttons-ticket-history" }, { children: _jsx("div", __assign({ className: "mb-3", style: { marginRight: "1rem" } }, { children: _jsx(TicketActions, { artHistory: artHistory, index: index, authRoleId: auth.role_id, authUserId: auth.id, hasImageResponse: hasImageResponse, artLink: artLink, lastStatusId: lastStatusId, isDisabledFlag: isDisabled, onContest: onContest, onAssess: onAssess }) })) }))] }))] })));
}
function TicketHistory() {
    var _a = useState([]), disapprovalOptions = _a[0], setDisapprovalOptions = _a[1];
    var _b = useState(false), showModalUploadTicket = _b[0], setShowModalUploadTicket = _b[1];
    var _c = useState([]), artHistories = _c[0], setArtHistories = _c[1];
    var _d = useState(false), openModalToDisapproveArt = _d[0], setOpenModalToDisapproveArt = _d[1];
    var _e = useState(false), artAssessmentModal = _e[0], setArtAssessmentModal = _e[1];
    var _f = useState(), art = _f[0], setArt = _f[1];
    var _g = useState(null), openIndex = _g[0], setOpenIndex = _g[1];
    var prod_url = process.env.REACT_APP_STORAGE_URL;
    var auth = useAuth().auth;
    var params = useParams();
    var artId = params.art_id;
    var location = useLocation();
    var _h = useState(''), materialLink = _h[0], setMaterialLink = _h[1];
    var triggeredStatusUpdateArtIdRef = useRef(undefined);
    useEffect(function () {
        if (artId) {
            getArtHistory(artId);
            getArtDisapprovalArts();
        }
    }, [artId]);
    useEffect(function () {
        getMaterialLink();
    }, []);
    useEffect(function () {
        setClarityTag("pageSection", "ticket-history-main");
    }, []);
    function getMaterialLink() {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, MemberHandbookService.memberHandbookURL().then(function (res) {
                            setMaterialLink(res.data.arts_url);
                        }, function () {
                            setMaterialLink('Link indisponível');
                        })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    }
    function getArtHistory(artId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                Notification().Block.circle("[data-id=arts-grid]");
                SubmissionsForProviderApprovalService.getArtHistory(artId)
                    .then(function (res) {
                    var history = res.data.artsHistory;
                    setArtHistories(history);
                    if (history.length > 0) {
                        setOpenIndex(0);
                    }
                    Notification().Block.remove("[data-id=arts-grid]");
                });
                return [2 /*return*/];
            });
        });
    }
    function getArtDisapprovalArts() {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, ArtsApprovalService.getArtDisapprovalOptions()
                            .then(function (res) {
                            setDisapprovalOptions(res.data.message);
                        })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    }
    ;
    function openModalToDisapproveTheArt(art) {
        setClarityTag("actionType", "ticket-history-disapprove-click");
        setArt(art);
        setArtAssessmentModal(false);
        setOpenModalToDisapproveArt(true);
    }
    ;
    function showModalUploadArts(arts) {
        setClarityTag("actionType", "ticket-history-assess-click");
        setArtAssessmentModal(true);
        setArt(arts);
    }
    ;
    function contestationAction(artId) {
        setClarityTag("actionType", "ticket-history-respond-click");
        setShowModalUploadTicket(true);
    }
    ;
    function toggleAccordion(index) {
        setClarityTag("actionType", "ticket-history-toggle-accordion");
        setOpenIndex(openIndex === index ? null : index);
    }
    ;
    useEffect(function () {
        if (artId && artHistories.length > 0 && triggeredStatusUpdateArtIdRef.current !== artId) {
            var latestHistory = artHistories[0];
            var hasDesigner = latestHistory.designer_id;
            if (hasDesigner && latestHistory.status_id !== 2) {
                triggeredStatusUpdateArtIdRef.current = artId;
                ArtsApprovalService.triggerStatusUpdate(Number(artId))
                    .then(function () {
                    getArtHistory(artId);
                });
            }
        }
    }, [artId, artHistories]);
    return (_jsxs("div", __assign({ className: "content-internal-padding", "data-id": "arts-grid" }, { children: [_jsx("div", { children: _jsx(Title, { text: "Hist\u00F3rico da Solicita\u00E7\u00E3o #".concat(artId), hr: true }) }), artHistories && Object.values(artHistories).map(function (artHistory, index) { return (_jsx(TicketHistoryItem, { artHistory: artHistory, index: index, artHistories: artHistories, auth: auth, disapprovalOptions: disapprovalOptions, materialLink: materialLink, isOpen: openIndex === index, onToggle: function () { return toggleAccordion(index); }, onContest: function () { return contestationAction(artHistory.id); }, onAssess: function () { return showModalUploadArts(art); } }, artHistory.id)); }), _jsx(ModalUploadTicket, { showModalUploadTicket: showModalUploadTicket, closeModalUploadTicket: function () { setShowModalUploadTicket(false); }, artHistories: artHistories }), _jsx(ModalApproveOrDisapproveArt, { showArtAssessmentModal: artAssessmentModal, closeArtAssessmentModal: function () { setArtAssessmentModal(false); }, callbackOpenModalToDisapproveTheArt: openModalToDisapproveTheArt, artHistories: artHistories, openModalToDisapproveArt: openModalToDisapproveArt, closeopenModalToDisapproveArt: function () { setOpenModalToDisapproveArt(false); } })] })));
}
export default TicketHistory;
